import PurchaseChannelSelector from './PurchaseChannelSelector';

export default PurchaseChannelSelector;
